import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../shared/providers/validation.service';
import { LoaderService } from '../shared/providers/loader.service';
import { IPropertyCard } from '../shared/models/propertycard';
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ToastService } from '../shared/providers/toast.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { RestService } from '../shared/providers/rest.service';
import { IResponseModel } from '../shared/models/ResponseModel';
import { MultipleEmailIdModel } from '../shared/models/MultipleEmailIdModel';
import { Trade1031Service } from '../shared/providers/Trade1031.service';
import { PropertyId } from '../shared/models/ComparePropertiesModel';

interface ISuggestPropertyListing {
  EmailForShare: string[];
  GroupId?: number;
  GroupName: string;
  SharedUserId: number;
  CreatedDate: Date;
  ExpiryDate: Date;
  ExchangeID: number;
}

interface ISuggestedList {
  PropertyId: number;
  PropertyName: string;
  FullAddress: string;
  PropertyStatus: string;
}

export class PropertyExchangeList {
  suggestedProperties: ISuggestedList[];
  exchangeList: number[];
}

export class SuggestedProprtiesAndExchange {
  PropertyId: number;
  ExchangeID: number;
  UserId: number;
  ExchangeGroupID: number = 2200
}

@Component({
  selector: 'app-suggest-multiple-properties',
  templateUrl: './suggest-multiple-properties.component.html',
  styleUrls: ['./suggest-multiple-properties.component.css']
})
export class SuggestMultiplePropertiesComponent implements OnInit {
  suggForm: FormGroup;
  constructor(
    public authService: AuthenticationService, private trade1031Service: Trade1031Service,
    private _toastService: ToastService, protected loaderService: LoaderService
    ) {
    
  }

  @Input() selectedProperties: IPropertyCard[];
  @Input() modalRefSuggestProperties: BsModalRef;
  @Output() removeProperties = new EventEmitter();
  suggestedListing = {} as ISuggestPropertyListing;
  exchangeLst= [];
  suggstedLst: ISuggestedList[];
  propCharcObj: number[];
  saveLst: SuggestedProprtiesAndExchange[];
  saveObj : SuggestedProprtiesAndExchange;
  user: any;
  defaultTypeSettings = {
    singleSelection: false,
    text: "Select",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
    badgeShowLimit: 1
  };
  //defaultTypeText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select',
  //  searchEmptyResult: 'No active exchanges found'
  //};


  ngOnInit() {
    this.suggForm = new FormGroup({
      'lstCharacteristic': new FormControl(this.suggestedListing.ExchangeID)
    });
    this.getExchangeDetails();
    this.suggstedLst = [];

    this.selectedProperties.forEach(item => {
      const property =
      {
        PropertyId: item.Id,
        PropertyName: item.PropertyName,
        FullAddress: item.FullAddress,
        PropertyStatus: item.PropertyStatus
      }
      this.suggstedLst.push(property);
    });
  }
get lstCharacteristic() { return this.suggForm.get('lstCharacteristic'); }
  getExchangeDetails() {
    this.user = this.authService.user;
    this.trade1031Service.GetExchangeCode(this.user.Id).subscribe(res => {
      this.exchangeLst = res.map(o => {
        return {
          id: o["Id"], name: o["ExchangeCode"]
        };
      });
    });
  }

  removeProperty(propertyId: number, index: number) {
    let prop = this.selectedProperties.find(x => x.Id == propertyId);
    prop.IsSelected = false;
    this.suggstedLst.splice(index, 1);
    this.removeProperties.emit(propertyId);
  }

  onExchangeSelect(selectedValues: any) {
    this.propCharcObj = selectedValues;
  }

  suggestList() {
    this.saveLst = [];
  if(this.suggstedLst.length>0 && this.propCharcObj!=null && this.propCharcObj.length>0)
  {
    this.suggstedLst.forEach(item => {
      this.propCharcObj.forEach(items => {
        this.saveObj = new SuggestedProprtiesAndExchange;
        this.saveObj.PropertyId = item.PropertyId;
        this.saveObj.ExchangeID = items;
        this.saveObj.UserId = this.user.Id
        this.saveLst.push(this.saveObj);
      });
    });
    this.trade1031Service.SuggestBulkProperties(this.saveLst).subscribe(res => {
      this.loaderService.display(true);
      if (res) {
        this._toastService.addToast({
          title: 'Success',
          msg: 'Property suggested successfully',
          timeout: 5000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'success'
        });
        this.selectedProperties.forEach(item => {
          item.IsSelected = false;
        });
        this.removeProperties.emit(0);
      }
      else {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to submit request ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.modalRefSuggestProperties.hide();
      this.loaderService.display(false);
    });
   }
   else
   {
        this._toastService.addToast({ title: 'Error Occurred', msg: 'Failed to submit request ', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        this.modalRefSuggestProperties.hide();
        this.loaderService.display(false);
    }
  }
}
